import { render, staticRenderFns } from "./GlossVariantUsageExampleItem.vue?vue&type=template&id=a6dd3c2e&"
import script from "./GlossVariantUsageExampleItem.vue?vue&type=script&lang=ts&"
export * from "./GlossVariantUsageExampleItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports